import Post from "../post/Post";
import Share from "../share/Share";
import "./diary.css";

import { PersonalPost } from "../../dummyData";

export default function Diary() {
  return (
    <div className="diary">
      <div className="feedWrapper">
        <Share />
        {PersonalPost.map(p => (
          <Post key={p.id} post={p} />
        ))}
      </div>
    </div>
  );
}
